import React from "react";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import Chip from "components/Chip";
import {getIncidentPriorityScoreColor} from "utils/priorityScore";
import PriorityScoreBreakdown from "./PriorityScoreBreakdown";

export default function PriorityScore({
  incident,
  labelProps,
  showLabel = true,
  ...rest
}) {
  const {t} = useTranslation();
  const {scores} = incident;
  if (!scores) return null;

  return (
    scores?.global && (
      <div className="d-flex align-center">
        {showLabel && (
          <span className="mr-1" {...labelProps}>
            {t("incidents.priorityScore.label")}
          </span>
        )}
        <Chip
          data-testid="Priority-Score"
          style={getIncidentPriorityScoreColor(scores?.global)}
          popoverContent={<PriorityScoreBreakdown {...{incident}} />}
          {...rest}>
          {scores?.global}
        </Chip>
      </div>
    )
  );
}

PriorityScore.propTypes = {
  /**
   * Incident object
   */
  incident: PropTypes.object.isRequired,
  /**
   * Option to pass in props to the label "Priority"
   */
  labelProps: PropTypes.object,
  /**
   * If false, the "Priority" label will be hidden
   *
   * @defaultValue true
   */
  showLabel: PropTypes.bool
};
